import { scaleLinear } from '@visx/vendor/d3-scale';
import scaleOperator from "../operators/scaleOperator.js";
export const updateLinearScale = scaleOperator('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
export default function createLinearScale(config) {
  return updateLinearScale(scaleLinear(), config);
}